import PortugalIcon from '@/components/Icons/PortugalIcon.vue'
import SouthKoreaIcon from '@/components/Icons/SouthKoreaIcon.vue'
import SpainIcon from '@/components/Icons/SpainIcon.vue'
import ThailandIcon from '@/components/Icons/ThailandIcon.vue'
import UnitedKingdomIcon from '@/components/Icons/UnitedKingdomIcon.vue'
import ChineseIcon from '@/components/Icons/ChineseIcon.vue'
import JapaneseIcon from '@/components/Icons/JapaneseIcon.vue'

export const languagesList = [
  {
    language: 'English',
    flag: UnitedKingdomIcon,
    abbreviation: 'en'
  },
  {
    language: 'Português',
    flag: PortugalIcon,
    abbreviation: 'pt'
  },
  {
    language: 'Español',
    flag: SpainIcon,
    abbreviation: 'es'
  },
  {
    language: 'ไทย',
    flag: ThailandIcon,
    abbreviation: 'th'
  },
  {
    language: '한국어',
    flag: SouthKoreaIcon,
    abbreviation: 'ko'
  },
  {
    language: '简体中文',
    flag: ChineseIcon,
    abbreviation: 'zh-hans'
  },
  {
    language: '繁體中文',
    flag: ChineseIcon,
    abbreviation: 'zh-hant'
  },
  {
    language: '日本語',
    flag: JapaneseIcon,
    abbreviation: 'jp'
  }
]
